import React from 'react';
import { withContext } from '../utils/StateProvider';
import { playSound } from '../utils/audio';

// Twelve beads around the gold mount
const BEADS = Array.from({ length: 12 }, (_, i) => {
  const angle = (i / 12) * Math.PI * 2;
  return { x: 50 + Math.cos(angle) * 44, y: 50 + Math.sin(angle) * 44 };
});

// The gem set in the bottom of the view frame, as in Might and Magic IV and V.
// Pressing it opens the game menu.
function GemButton({ context }) {
  if (context.screen !== 'playing') return null;

  return (
    <div
      id="gemButton"
      title="Game menu"
      onClick={() => { playSound('click'); context.toggleGameMenu(); }}
    >
      <svg viewBox="0 0 100 100">
        <defs>
          <radialGradient id="gemStone" cx="38%" cy="32%">
            <stop offset="0%" stopColor="#f0c4ff" />
            <stop offset="35%" stopColor="#b25fe0" />
            <stop offset="75%" stopColor="#6c1ea0" />
            <stop offset="100%" stopColor="#3a0a5c" />
          </radialGradient>
          <linearGradient id="gemMount" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#f6dc95" />
            <stop offset="45%" stopColor="#b98f36" />
            <stop offset="100%" stopColor="#6f5119" />
          </linearGradient>
        </defs>

        <circle cx="50" cy="50" r="48" fill="url(#gemMount)" />
        <circle cx="50" cy="50" r="40" fill="#2a1c08" />
        {BEADS.map((bead, i) => (
          <circle key={i} cx={bead.x} cy={bead.y} r="3.4" fill="url(#gemMount)" stroke="#5c4415" strokeWidth="0.6" />
        ))}

        <circle cx="50" cy="50" r="36" fill="url(#gemStone)" />
        {/* A few facets catching the light */}
        <polygon points="50,16 74,40 50,50" fill="#ffffff" opacity="0.16" />
        <polygon points="50,16 26,40 50,50" fill="#ffffff" opacity="0.09" />
        <polygon points="26,40 50,84 50,50" fill="#000000" opacity="0.18" />
        <polygon points="74,40 50,84 50,50" fill="#000000" opacity="0.10" />
        <ellipse cx="40" cy="32" rx="11" ry="7" fill="#ffffff" opacity="0.35" transform="rotate(-25 40 32)" />
      </svg>
    </div>
  );
}

export default withContext(GemButton);
